<p-dialog [(visible)]="visible" [style]="{width: '60vw',height: '100vh'}" appendTo="body" [maximizable]="true"
  [baseZIndex]="1000" (onHide)="handleDialogClose()">
  <ng-template #header>
    <div style="flex-grow: 1;justify-content: center; display: flex; gap: 20px; margin-left: 3.5rem;">
      <p-button *ngIf="visiblebtn" label="Guardar" (onClick)="TransaccionEntidad('I', 0)"></p-button>
      <p-button *ngIf="!visiblebtn" label="Actualizar" (onClick)="TransaccionEntidad('U', 0)"></p-button>
      <p-button label="Salir" (onClick)="salir()"></p-button>
    </div>
  </ng-template>

  <p-tabView class="a-example-full-width-alterno-content" [activeIndex]="activeIndex"
    (onChange)="activeIndex = $event.index">
    <p-tabPanel header="Datos Generales">
      <form [formGroup]="groupPoppupDG" class="form-container">
        <p-toast key="toast1"></p-toast>
        <p-toast key="toast2"></p-toast>
        <p-toast key="toast3"></p-toast>

        <div class="form-row-2-cols">
          <p-floatlabel variant="in" class="input-half-width">
            <p-select [options]="listTipoDocFiltrado" optionLabel="nombre" formControlName="tipodocumento"
              optionValue="codigo" appendTo="body" styleClass="w-full md:w-full text-xs" />
            <label for="tipodocumento">Tipo Documento</label>
          </p-floatlabel>

          <p-inputgroup *ngIf="visiblenumdoc">
            <p-floatlabel variant="in">
              <input formControlName="numerodocumento" pInputText type="text" class="w-full md:w-full"
                [ngClass]="{'ng-invalid ng-dirty': groupPoppupDG.get('numerodocumento')?.invalid && (groupPoppupDG.get('numerodocumento')?.dirty || groupPoppupDG.get('numerodocumento')?.touched)}" />
              <label for="numerodocumento">Número Documento</label>
            </p-floatlabel>
            <button type="button" pButton pRipple icon="pi pi-search" (click)="validarDocumento()"
              styleClass="p-button-info"></button>
          </p-inputgroup>
        </div>

        <div class="form-row-2-cols">
          <div class="input-full-width">
            <p-floatlabel variant="in">
              <p-select [options]="ListarTipoCliente" optionLabel="name" optionValue="value"
                formControlName="tipoCliente" styleClass="w-full md:w-full text-xs" appendTo="body"
                [ngClass]="{'ng-invalid ng-dirty': groupPoppupDG.get('tipoCliente')?.invalid && (groupPoppupDG.get('tipoCliente')?.dirty || groupPoppupDG.get('tipoCliente')?.touched)}" />
              <label for="tipoCliente">Tipo Cliente</label>
            </p-floatlabel>
          </div>

          <div class="input-group-half">
            <p-floatlabel variant="in">
              <input formControlName="codigo" type="text" pInputText [readOnly]="true" class="w-full md:w-full" />
              <label for="float-label">Código</label>
            </p-floatlabel>
          </div>
        </div>

        <div class="form-row-3-cols">
          <div class="radio-group">
            <label class="radio-label">
              <input id="pjuridica" type="radio" formControlName="tipopersona" value="J" /> Jurídica
            </label>
            <label class="radio-label">
              <input id="pnatural" type="radio" formControlName="tipopersona" value="N" /> Natural
            </label>
          </div>

          <div class="checkbox-group">
            <div class="checkbox-item">
              <p-checkbox formControlName="serviciologistico" [binary]="true" inputId="serviciologistico"></p-checkbox>
              <label for="serviciologistico">Servicio Logístico</label>
            </div>
            <div class="checkbox-item" *ngIf="estadoEditar == false">
              <p-checkbox formControlName="informar_facturacion" [binary]="true" inputId="facturacion"></p-checkbox>
              <label for="facturacion">Enviar Correo a Facturación</label>
              <i class="pi pi-exclamation-circle"
                pTooltip="Envío de correo Nuevo Cliente registrado al área de facturación" tooltipPosition="right"></i>
            </div>
          </div>
          <div class="checkbox-group">
            <div class="checkbox-item">
              <p-checkbox formControlName="activo" [binary]="true" inputId="activo"></p-checkbox>
              <label for="activo">Activo</label>
            </div>
            <ng-container *ngIf="groupPoppupDG.get('tipoCliente')?.value === '004'">
              <div class="checkbox-item">
                <p-checkbox formControlName="almacen" [binary]="true" inputId="almacen"></p-checkbox>
                <label for="almacen">Almacén</label>
              </div>
            </ng-container>
          </div>
        </div>



        <ng-container *ngIf="groupPoppupDG.get('tipopersona')?.value === 'J'">
          <div class="form-row-2-cols">
            <p-floatlabel variant="in">
              <input formControlName="razonsocial" pInputText type="text"
                [ngClass]="{'ng-invalid ng-dirty': groupPoppupDG.get('razonsocial')?.invalid && (groupPoppupDG.get('razonsocial')?.dirty || groupPoppupDG.get('razonsocial')?.touched)}" />
              <label for="razonsocial">Razón Social</label>
            </p-floatlabel>

            <p-floatlabel variant="in">
              <input formControlName="razoncomercial" pInputText type="text"
                [ngClass]="{'ng-invalid ng-dirty': groupPoppupDG.get('razoncomercial')?.invalid && (groupPoppupDG.get('razoncomercial')?.dirty || groupPoppupDG.get('razoncomercial')?.touched)}" />
              <label for="razoncomercial">Razón Comercial</label>
            </p-floatlabel>
          </div>

          <div class="form-row-2-cols">
            <p-floatlabel variant="in">
              <input formControlName="estadoSunat" pInputText type="text"
                [ngClass]="{'ng-invalid ng-dirty': groupPoppupDG.get('estadoSunat')?.invalid && (groupPoppupDG.get('estadoSunat')?.dirty || groupPoppupDG.get('estadoSunat')?.touched)}" />
              <label for="estadoSunat">Estado Sunat</label>
            </p-floatlabel>
            <p-inputgroup *ngIf="groupPoppupDG.get('tipoCliente')?.value === '004'">
              <p-floatlabel variant="in">
                <input formControlName="detalleQunac" pInputText type="text" />
                <label for="detalleQunac">Estado Qunac</label>
              </p-floatlabel>
              <button type="button" pButton pRipple icon="pi pi-search" (click)="validarEstadoQunac()"
                styleClass="p-button-info"></button>
            </p-inputgroup>
          </div>
        </ng-container>

        <ng-container *ngIf="groupPoppupDG.get('tipopersona')?.value === 'N'">
          <div class="form-row-2-cols">
            <p-floatlabel variant="in">
              <input formControlName="apellidopaterno" pInputText type="text"
                [ngClass]="{'ng-invalid ng-dirty': groupPoppupDG.get('apellidopaterno')?.invalid && (groupPoppupDG.get('apellidopaterno')?.dirty || groupPoppupDG.get('apellidopaterno')?.touched)}" />
              <label for="apellidopaterno">Apellido Paterno</label>
            </p-floatlabel>

            <p-floatlabel variant="in">
              <input formControlName="apellidomaterno" pInputText type="text"
                [ngClass]="{'ng-invalid ng-dirty': groupPoppupDG.get('apellidomaterno')?.invalid && (groupPoppupDG.get('apellidomaterno')?.dirty || groupPoppupDG.get('apellidomaterno')?.touched)}" />
              <label for="apellidomaterno">Apellido Materno</label>
            </p-floatlabel>
          </div>

          <div class="form-row-2-cols">
            <p-floatlabel variant="in">
              <input formControlName="nombres" pInputText type="text"
                [ngClass]="{'ng-invalid ng-dirty': groupPoppupDG.get('nombres')?.invalid && (groupPoppupDG.get('nombres')?.dirty || groupPoppupDG.get('nombres')?.touched)}" />
              <label for="nombres">Nombres</label>
            </p-floatlabel>

            <div class="radio-group-horizontal">
              <label *ngFor="let s of sexo" class="radio-label">
                <p-radioButton [inputId]="s.key" [value]="s.key" formControlName="sexo"></p-radioButton>
                <span>{{ s.name }}</span>
              </label>
            </div>
          </div>

          <div class="form-row-2-cols">
            <p-floatlabel variant="in">
              <input formControlName="area" pInputText type="text"
                [ngClass]="{'ng-invalid ng-dirty': groupPoppupDG.get('area')?.invalid && (groupPoppupDG.get('area')?.dirty || groupPoppupDG.get('area')?.touched)}" />
              <label for="area">Área</label>
            </p-floatlabel>

            <p-floatlabel variant="in">
              <input formControlName="cargo" pInputText type="text"
                [ngClass]="{'ng-invalid ng-dirty': groupPoppupDG.get('cargo')?.invalid && (groupPoppupDG.get('cargo')?.dirty || groupPoppupDG.get('cargo')?.touched)}" />
              <label for="cargo">Cargo</label>
            </p-floatlabel>
          </div>

          <div class="form-row-2-cols">
            <p-floatlabel variant="in" class="w-full md:w-full">
              <p-datepicker formControlName="fechanacimiento" appendTo="body" [showIcon]="true" dateFormat="dd/mm/yy"
                styleClass="w-full md:w-full" [maxDate]="fechaActual"></p-datepicker>
              <label for="fechanacimiento">Fecha Nacimiento</label>
            </p-floatlabel>

            <p-floatlabel variant="in" class="w-full md:w-full">
              <p-datepicker formControlName="fechaingreso" appendTo="body" [showIcon]="true" dateFormat="dd/mm/yy"
                styleClass="w-full md:w-full"></p-datepicker>
              <label for="fechaingreso">Fecha Ingreso</label>
            </p-floatlabel>
          </div>
        </ng-container>

        <div class="form-row-full-width">
          <p-floatlabel variant="in">
            <input formControlName="nomgerente" pInputText type="text" class="w-full md:w-full" />
            <label for="float-label">Nombre Gerente</label>
          </p-floatlabel>
        </div>

        <div class="form-row-2-cols">
          <ng-container *ngIf="groupPoppupDG.get('tipoCliente')?.value !== '004'">
            <p-floatlabel variant="in" class="w-full md:w-full">
              <p-datepicker formControlName="fechanacimientog" appendTo="body" [showIcon]="true"
                styleClass="w-full md:w-full" dateFormat="dd/mm/yy" [maxDate]="fechaActual">
              </p-datepicker>
              <label for="float-label">Fecha Nacimiento</label>
            </p-floatlabel>
          </ng-container>
          <p-floatlabel variant="in" class="w-full md:w-full">
            <p-datepicker formControlName="fechaAniversariog" appendTo="body" [showIcon]="true" dateFormat="dd/mm/yy"
              styleClass="w-full md:w-full"></p-datepicker>
            <label for="float-label">Fecha Aniversario</label>
          </p-floatlabel>
        </div>

        <ng-container *ngIf="groupPoppupDG.get('tipoCliente')?.value == '004'">
          <div class="form-row-2-cols">
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="correo2" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Correo Contrato Mandato</label>
            </p-floatlabel>
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="correo_otros_traficos2" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Correo Otros Tráficos</label>
            </p-floatlabel>
          </div>

          <div class="form-row-2-cols">
            <p-floatlabel variant="in">
              <input formControlName="correoexport2" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Correo Exportaciones</label>
            </p-floatlabel>
            <p-floatlabel variant="in">
              <input formControlName="correo_facturacion2" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Correo Facturación</label>
            </p-floatlabel>
          </div>

        </ng-container>

        <ng-container *ngIf="groupPoppupDG.get('tipoCliente')?.value !== '004'">

          <div class="form-row-2-cols">
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="correo" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Correo Contrato Mandato</label>
            </p-floatlabel>
            <p-floatlabel variant="in" class="a-w1">
              <input formControlName="correo_otros_traficos" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Correo Otros Tráficos</label>
            </p-floatlabel>
          </div>

          <div class="form-row-2-cols">
            <p-floatlabel variant="in">
              <input formControlName="contactonombre" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Contacto Nombre</label>
            </p-floatlabel>
            <p-floatlabel variant="in">
              <input formControlName="contactoapellidos" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Apellidos</label>
            </p-floatlabel>
          </div>
          <div class="form-row-2-cols">
            <p-floatlabel variant="in">
              <input formControlName="correoexport" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Correo Exportaciones</label>
            </p-floatlabel>
            <p-floatlabel variant="in">
              <input formControlName="correo_facturacion" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Correo Facturación</label>
            </p-floatlabel>
          </div>
          <div class="form-row-2-cols">
            <p-floatlabel variant="in">
              <p-select [options]="ListarTodosSegmento" placeholder="‎ " optionLabel="nombre" formControlName="segmento"
                optionValue="codigo" appendTo="body" styleClass="w-full md:w-full text-xs">
              </p-select>
              <label for="float-label">Segmento</label>
            </p-floatlabel>
            <p-floatlabel variant="in">
              <input formControlName="web" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Web</label>
            </p-floatlabel>
          </div>
          <div class="form-row-2-cols">
            <p-floatlabel variant="in">
              <input formControlName="telefono_fijo" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Teléfono Fijo</label>
            </p-floatlabel>
            <p-floatlabel variant="in">
              <input formControlName="telefono_movil" pInputText type="text" class="w-full md:w-full" />
              <label for="float-label">Teléfono Móvil</label>
            </p-floatlabel>
          </div>
        </ng-container>


        <ng-container *ngIf="groupPoppupDG.get('tipoCliente')?.value === '004'">
          <div class="form-row-2-cols">
            <p-floatlabel variant="in" class="input-full-width">
              <p-multiSelect [options]="ListarNuevoSegmento" optionLabel="name" formControlName="segmentoNuevo"
                [maxSelectedLabels]="3" optionValue="value" appendTo="body" styleClass="w-full md:w-full text-xs" />
              <label for="segmentoNuevo">Segmentos</label>
            </p-floatlabel>

            <p-floatlabel variant="in" class="input-full-width">
              <p-multiSelect [options]="ListarDetallesSegmento" formControlName="detallesSegmento"
                [maxSelectedLabels]="5" optionLabel="name" [filter]="true" appendTo="body"
                styleClass="w-full md:w-full text-xs" />
              <label for="detallesSegmento">Listado de Segmentos</label>
            </p-floatlabel>
          </div>
        </ng-container>

        <div class="form-row-full-width">
          <p-floatlabel variant="in">
            <input formControlName="direccion" pInputText type="text"
              [ngClass]="{'ng-invalid ng-dirty': groupPoppupDG.get('direccion')?.invalid && (groupPoppupDG.get('direccion')?.dirty || groupPoppupDG.get('direccion')?.touched)}" />
            <label for="direccion">Dirección Fiscal</label>
          </p-floatlabel>
        </div>

        <div class="form-row-2-cols">
          <p-floatlabel variant="in">
            <p-select [options]="listPais" appendTo="body" formControlName="pais" optionLabel="nombre"
              optionValue="codigo" styleClass="w-full md:w-full text-xs" [filter]="true" [showClear]="true"
              (onChange)="onPaisSeleccionado($event, 'fiscal', 'EVE')" />
            <label for="pais">País</label>
          </p-floatlabel>
          <p-floatlabel variant="in">
            <p-select [options]="listDepartamento" appendTo="body" optionLabel="ubiG_Desc"
              formControlName="departamento" optionValue="ubiG_Codigo" styleClass="w-full md:w-full text-xs"
              [filter]="true" [showClear]="true" (onChange)="onDepartamentoSeleccionado($event, 'fiscal', 'EVE')" />
            <label for="departamento">Departamento</label>
          </p-floatlabel>
        </div>

        <div class="form-row-2-cols">
          <p-floatlabel variant="in">
            <p-select [options]="listProvincia" appendTo="body" formControlName="provincia" optionLabel="ubiG_Desc"
              optionValue="ubiG_Codigo" styleClass="w-full md:w-full text-xs" [filter]="true" [showClear]="true"
              (onChange)="onprovinciaSeleccionada($event, 'fiscal', 'EVE')" />
            <label for="provincia">Provincia</label>
          </p-floatlabel>
          <p-floatlabel variant="in">
            <p-select [options]="listDistrito" appendTo="body" optionLabel="ubiG_Desc" formControlName="distrito"
              optionValue="ubiG_Codigo" styleClass="w-full md:w-full text-xs" [filter]="true" [showClear]="true" />
            <label for="distrito">Distrito</label>
          </p-floatlabel>
        </div>

        <ng-container *ngIf="groupPoppupDG.get('tipoCliente')?.value === '004'">
          <div class="section-title">
            <h4>Datos Comerciales</h4>
          </div>
          <div class="form-row-full-width">
            <p-floatlabel variant="in">
              <input formControlName="direccionComercial" pInputText type="text" />
              <label for="direccionComercial">Dirección Comercial</label>
            </p-floatlabel>
          </div>
          <div class="form-row-2-cols">
            <p-floatlabel variant="in">
              <p-select [options]="listPais" appendTo="body" formControlName="paisComercial" optionLabel="nombre"
                optionValue="codigo" styleClass="w-full md:w-full text-xs" [filter]="true" [showClear]="true"
                (onChange)="onPaisSeleccionado($event, 'comercial', 'EVE')" />
              <label for="paisComercial">País</label>
            </p-floatlabel>
            <p-floatlabel variant="in">
              <p-select [options]="listDepartamentoComercial" appendTo="body" optionLabel="ubiG_Desc"
                formControlName="departamentoComercial" optionValue="ubiG_Codigo" styleClass="w-full md:w-full text-xs"
                [filter]="true" [showClear]="true"
                (onChange)="onDepartamentoSeleccionado($event, 'comercial', 'EVE')" />
              <label for="departamentoComercial">Departamento</label>
            </p-floatlabel>
          </div>
          <div class="form-row-2-cols">
            <p-floatlabel variant="in">
              <p-select [options]="listProvinciaComercial" appendTo="body" formControlName="provinciaComercial"
                optionLabel="ubiG_Desc" optionValue="ubiG_Codigo" styleClass="w-full md:w-full text-xs" [filter]="true"
                [showClear]="true" (onChange)="onprovinciaSeleccionada($event, 'comercial', 'EVE')" />
              <label for="provinciaComercial">Provincia</label>
            </p-floatlabel>
            <p-floatlabel variant="in">
              <p-select [options]="listDistritoComercial" appendTo="body" optionLabel="ubiG_Desc"
                formControlName="distritoComercial" optionValue="ubiG_Codigo" styleClass="w-full md:w-full text-xs"
                [filter]="true" [showClear]="true" />
              <label for="distritoComercial">Distrito</label>
            </p-floatlabel>
          </div>
        </ng-container>

        <div class="form-row-2-cols">
          <p-floatlabel variant="in" class="w-full md:w-full">
            <p-datepicker formControlName="fechacredito" appendTo="body" [showIcon]="true" dateFormat="dd/mm/yy"
              styleClass="w-full md:w-full"></p-datepicker>
            <label for="float-label">Fecha Crédito</label>
          </p-floatlabel>
          <p-floatlabel variant="in" class="input-with-checkbox">
            <p-inputNumber inputId="minmax-buttons" [showButtons]="true" [min]="0" formControlName="diascreditos"
              class="w-full md:w-full"></p-inputNumber>
            <label for="diascreditos">Días Créditos</label>
          </p-floatlabel>
        </div>

        <div class="form-row-2-cols">
          <div class="checkbox-item">
            <p-checkbox formControlName="nodomiciliado" [binary]="true" inputId="nodomiciliado"></p-checkbox>
            <label for="nodomiciliado">No Domiciliado</label>
          </div>
          <div class="checkbox-item">
            <p-checkbox formControlName="to_order" [binary]="true" inputId="to_order"></p-checkbox>
            <label for="to_order">To Order</label>
          </div>
        </div>

        <div class="form-row-full-width">
          <label for="observaciones" class="section-label">Observaciones</label>
          <p-floatlabel variant="in">
            <textarea rows="5" pInputTextarea formControlName="observaciones" cols="30" style="width: 100%;"></textarea>
          </p-floatlabel>
        </div>

        <!-- <div class="form-row-2-cols">
          <p-floatlabel variant="in">
            <input formControlName="sigla" pInputText type="text" maxlength="10"
              [ngClass]="{'ng-invalid ng-dirty': groupPoppupDG.get('sigla')?.invalid && (groupPoppupDG.get('sigla')?.dirty || groupPoppupDG.get('sigla')?.touched)}" />
            <label for="sigla">Sigla</label>
          </p-floatlabel>
        </div> -->
      </form>
    </p-tabPanel>
    <p-tabPanel header="Datos Comerciales"
      [headerStyle]="{'display': (groupPoppupDG.get('tipoCliente')?.value === '004' ? 'block' : 'none')}">
      <p-toast key="toast1"></p-toast>
      <p-toast key="toast2"></p-toast>
      <p-toast key="toast3"></p-toast>
      <!-- <form [formGroup]="groupDatosComerciales" class="a-w1" style="margin: 0;" (ngSubmit)="onSubmitComercial()"> -->
      <form [formGroup]="groupDatosComerciales" class="a-w1" style="margin: 0;">
        <!-- <div class="checkbox-item">
          <p-checkbox formControlName="pruebas" [binary]="true" inputId="pruebas"></p-checkbox>
          <label for="pruebas">Hacer opcional (Para pruebas)</label>
        </div> -->
        <div class="card p-2">
          <p-accordion [value]="['0']" [multiple]="true">
            <p-accordion-panel value="0">
              <p-accordion-header>
                <div class="accordion-header">
                  <i class="pi pi-user accordion-icon" style="color: #0f4d7e;"></i>
                  <span>Contacto Principal</span>
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <div formGroupName="contactoPrincipal" class="form-section">
                  <div class="checkbox-item">
                    <p-checkbox formControlName="checkOpcional" [binary]="true"
                      inputId="checkOpcionalPrincipal"></p-checkbox>
                    <label for="checkOpcionalPrincipal">Hacer opcional</label>
                  </div>

                  <div class="flex-align-center">

                    <p-checkbox formControlName="replicateFromPrincipalall" [binary]="true"
                      pTooltip="Debe llenar al menos un campo para poder replicar" tooltipPosition="right"
                      (onChange)='replicatePrincipalToAll()'></p-checkbox>


                    <!-- [disabled]="!hasAnyValue('principal', contactoPrincipalForm )" -->

                    <label class="label-replicate">

                      Replicar información en todo los contactos.

                    </label>

                  </div>

                  <div class="form-grid">
                    <p-floatlabel variant="in">
                      <input formControlName="nombre" type="text" pInputText class="full-width"
                        [ngClass]="{'ng-invalid ng-dirty': groupDatosComerciales.get('contactoPrincipal.nombre')?.invalid && (groupDatosComerciales.get('contactoPrincipal.nombre')?.dirty || groupDatosComerciales.get('contactoPrincipal.nombre')?.touched)}" />
                      <label for="nombre-principal">Nombre</label>
                    </p-floatlabel>
                    <p-floatlabel variant="in">
                      <input formControlName="apellido" type="text" pInputText class="full-width"
                        [ngClass]="{'ng-invalid ng-dirty': groupDatosComerciales.get('contactoPrincipal.apellido')?.invalid && (groupDatosComerciales.get('contactoPrincipal.apellido')?.dirty || groupDatosComerciales.get('contactoPrincipal.apellido')?.touched)}" />
                      <label for="apellido-principal">Apellido</label>
                    </p-floatlabel>
                  </div>
                  <div>
                    <p-floatlabel variant="in">
                      <input formControlName="puesto" type="text" pInputText class="full-width"
                        [ngClass]="{'ng-invalid ng-dirty': groupDatosComerciales.get('contactoPrincipal.puesto')?.invalid && (groupDatosComerciales.get('contactoPrincipal.puesto')?.dirty || groupDatosComerciales.get('contactoPrincipal.puesto')?.touched)}" />
                      <label for="puesto-principal">Puesto</label>
                    </p-floatlabel>
                  </div>
                  <div class="form-grid">
                    <p-floatlabel variant="in">
                      <input formControlName="telefono" id="telefono-principal" type="tel" pInputText class="full-width"
                        [ngClass]="{'ng-invalid ng-dirty': groupDatosComerciales.get('contactoPrincipal.telefono')?.invalid && (groupDatosComerciales.get('contactoPrincipal.telefono')?.dirty || groupDatosComerciales.get('contactoPrincipal.telefono')?.touched)}" />
                      <label for="telefono-principal">Teléfono</label>
                    </p-floatlabel>
                    <p-floatlabel variant="in">
                      <p-datepicker formControlName="cumpleanos" appendTo="body" inputId="cumpleanos-principal" showIcon
                        iconDisplay="input" class="full-width"
                        [ngClass]="{'ng-invalid ng-dirty': groupDatosComerciales.get('contactoPrincipal.cumpleanos')?.invalid && (groupDatosComerciales.get('contactoPrincipal.cumpleanos')?.dirty || groupDatosComerciales.get('contactoPrincipal.cumpleanos')?.touched)}"></p-datepicker>
                      <label for="cumpleanos-principal">Cumpleaños</label>
                    </p-floatlabel>
                  </div>
                  <div>
                    <p-floatlabel variant="in" style="height: fit-content;">
                      <input formControlName="email" type="email" pInputText class="full-width"
                        [ngClass]="{'ng-invalid ng-dirty': groupDatosComerciales.get('contactoPrincipal.email')?.invalid && (groupDatosComerciales.get('contactoPrincipal.email')?.dirty || groupDatosComerciales.get('contactoPrincipal.email')?.touched)}" />
                      <label for="email-principal">Correo Electrónico</label>
                    </p-floatlabel>
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="1">
              <p-accordion-header>
                <div class="accordion-header">
                  <i class="pi pi-truck accordion-icon" style="color: #0f4d7e;"></i>
                  <span>Contacto Logística Internacional</span>
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <div class="checkbox-item">
                  <p-checkbox formControlName="checkOpcionalILC" [binary]="true" inputId="checkOpcionalILC"
                    (onChange)="haceropcionallogistica(getFormGroup(groupDatosComerciales.get('internationalLogisticsContacts')), $event.checked,groupDatosComerciales)"></p-checkbox>
                  <label for="checkOpcionalILC">Hacer opcional</label>
                </div>
                <div class="form-section">
                  <div *ngFor="let contactGroup of internationalLogisticsContactsArray.controls; let i = index"
                    [formGroup]="getFormGroup(contactGroup)" class="form-card">
                    <div class="form-card-header">

                      <h4 class="form-card-title">

                        Contacto {{ i + 1 }}

                      </h4>

                      <p-button *ngIf="internationalLogisticsContactsArray.length > 1" type="button" icon="pi pi-times"
                        label="Eliminar" styleClass="p-button-danger p-button-sm p-button-outlined"
                        (click)="removeLogisticsContact(i)"></p-button>

                    </div>
                    <div class="mb-4">

                      <div class="flex-align-center">

                        <p-checkbox formControlName="replicateFromPrincipal" [binary]="true"
                          pTooltip="Debe llenar al menos un campo para poder replicar" tooltipPosition="right"
                          inputId="replicate-log-{{contactGroup.get('id')?.value}}"
                          (onChange)="replicatePrincipalToLogistics(getFormGroup(contactGroup), $event.checked)"></p-checkbox>


                        <!-- [disabled]="!hasAnyValue('principal', contactoPrincipalForm )" -->

                        <label for="replicate-log-{{contactGroup.get('id')?.value}}" class="label-replicate">

                          Replicar información del Contacto Principal

                        </label>

                      </div>

                    </div>
                    <div class="form-space-y">
                      <div class="form-grid">
                        <p-floatlabel variant="in">
                          <input formControlName="name" type="text" pInputText class="full-width"
                            [ngClass]="{'ng-invalid ng-dirty': contactGroup.get('name')?.invalid && contactGroup.get('name')?.touched}" />
                          <label for="log_name-{{contactGroup.get('id')?.value}}">Nombre</label>
                        </p-floatlabel>
                        <p-floatlabel variant="in">
                          <input formControlName="lastName" type="text" pInputText class="full-width"
                            [ngClass]="{'ng-invalid ng-dirty': contactGroup.get('lastName')?.invalid && contactGroup.get('lastName')?.touched}" />
                          <label for="log_lastName-{{contactGroup.get('id')?.value}}">Apellido</label>
                        </p-floatlabel>
                      </div>
                      <div>
                        <p-floatlabel variant="in">
                          <input formControlName="position" type="text" pInputText class="full-width"
                            [ngClass]="{'ng-invalid ng-dirty': contactGroup.get('position')?.invalid && contactGroup.get('position')?.touched}" />
                          <label for="log_position-{{contactGroup.get('id')?.value}}">Puesto</label>
                        </p-floatlabel>
                      </div>
                      <div class="form-grid">
                        <p-floatlabel variant="in">
                          <input formControlName="phone" id="log_phone-{{contactGroup.get('id')?.value}}" type="tel"
                            pInputText class="full-width"
                            [ngClass]="{'ng-invalid ng-dirty': contactGroup.get('phone')?.invalid && contactGroup.get('phone')?.touched}" />
                          <label for="log_phone-{{contactGroup.get('id')?.value}}">Teléfono</label>
                        </p-floatlabel>
                        <p-floatlabel variant="in">
                          <p-datepicker formControlName="birthday" appendTo="body"
                            inputId="log_birthday-{{contactGroup.get('id')?.value}}" showIcon iconDisplay="input"
                            class="full-width"
                            [ngClass]="{'ng-invalid ng-dirty': contactGroup.get('birthday')?.invalid && contactGroup.get('birthday')?.touched}"></p-datepicker>
                          <label for="log_birthday-{{contactGroup.get('id')?.value}}">Cumpleaños</label>
                        </p-floatlabel>
                      </div>
                      <div class="form-grid">
                        <p-floatlabel variant="in" style="height: fit-content;">
                          <input formControlName="email" type="email" pInputText class="full-width"
                            [ngClass]="{'ng-invalid ng-dirty': contactGroup.get('email')?.invalid && contactGroup.get('email')?.touched}" />
                          <label for="log_email-{{contactGroup.get('id')?.value}}">Correo Electrónico</label>
                        </p-floatlabel>
                        <div>
                          <label class="label-email-type">Tipo de Correo</label>
                          <div formGroupName="emailTypes"
                            [ngClass]="{'ng-invalid': contactGroup.get('emailTypes')?.invalid && contactGroup.get('emailTypes')?.touched}">
                            <div class="flex-align-center">
                              <p-checkbox formControlName="mandato" [binary]="true"
                                inputId="log_mandato-{{contactGroup.get('id')?.value}}"></p-checkbox>
                              <label for="log_mandato-{{contactGroup.get('id')?.value}}"
                                class="label-checkbox">Mandato</label>
                            </div>
                            <div class="flex-align-center">
                              <p-checkbox formControlName="otrosTraficos" [binary]="true"
                                inputId="log_otros-traficos-{{contactGroup.get('id')?.value}}"></p-checkbox>
                              <label for="log_otros-traficos-{{contactGroup.get('id')?.value}}"
                                class="label-checkbox">Otros tráficos</label>
                            </div>
                            <div class="flex-align-center">
                              <p-checkbox formControlName="exportacion" [binary]="true"
                                inputId="log_exportacion-{{contactGroup.get('id')?.value}}"></p-checkbox>
                              <label for="log_exportacion-{{contactGroup.get('id')?.value}}"
                                class="label-checkbox">Exportación</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-actions">
                    <p-button type="button" icon="pi pi-plus" label="Agregar Nuevo Contacto"
                      styleClass="p-button-info p-button-rounded" (click)="addNewLogisticsContact()"></p-button>
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="2">
              <p-accordion-header>
                <div class="accordion-header">
                  <i class="pi pi-credit-card accordion-icon" style="color: #0f4d7e;"></i>
                  <span>Contacto Facturación</span>
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <div formGroupName="billingContact" class="form-section">
                  <div class="checkbox-item">
                    <p-checkbox formControlName="checkOpcional" [binary]="true" inputId="checkOpcionalBC"></p-checkbox>
                    <label for="checkOpcionalBC">Hacer opcional</label>
                  </div>

                  <div class="flex-align-center">

                    <p-checkbox formControlName="re+plicateFromPrincipal2" [binary]="false"
                      pTooltip="Debe llenar al menos un campo para poder replicar" tooltipPosition="right"
                      (onChange)="replicatePrincipalFacturcion(getFormGroup(groupDatosComerciales.get('billingContact')), $event.checked)"></p-checkbox>


                    <!-- [disabled]="!hasAnyValue('principal', contactoPrincipalForm )" -->

                    <label class="label-replicate">

                      Replicar información del Contacto Principal

                    </label>

                  </div>

                  <div class="form-grid">
                    <p-floatlabel variant="in">
                      <input formControlName="name" type="text" pInputText class="full-width"
                        [ngClass]="{'ng-invalid ng-dirty': groupDatosComerciales.get('billingContact.name')?.invalid && groupDatosComerciales.get('billingContact.name')?.touched}" />
                      <label for="fact_name">Nombre</label>
                    </p-floatlabel>
                    <p-floatlabel variant="in">
                      <input formControlName="lastName" type="text" pInputText class="full-width"
                        [ngClass]="{'ng-invalid ng-dirty': groupDatosComerciales.get('billingContact.lastName')?.invalid && groupDatosComerciales.get('billingContact.lastName')?.touched}" />
                      <label for="fact_lastName">Apellido</label>
                    </p-floatlabel>
                  </div>
                  <div>
                    <p-floatlabel variant="in">
                      <input formControlName="position" type="text" pInputText class="full-width"
                        [ngClass]="{'ng-invalid ng-dirty': groupDatosComerciales.get('billingContact.position')?.invalid && groupDatosComerciales.get('billingContact.position')?.touched}" />
                      <label for="fact_position">Puesto</label>
                    </p-floatlabel>
                  </div>
                  <div class="form-grid">
                    <p-floatlabel variant="in">
                      <input formControlName="phone" id="fact_phone" type="tel" pInputText class="full-width"
                        [ngClass]="{'ng-invalid ng-dirty': groupDatosComerciales.get('billingContact.phone')?.invalid && groupDatosComerciales.get('billingContact.phone')?.touched}" />
                      <label for="fact_phone">Teléfono</label>
                    </p-floatlabel>
                    <p-floatlabel variant="in">
                      <p-datepicker formControlName="birthday" appendTo="body" inputId="fact_birthday" showIcon
                        iconDisplay="input" class="full-width"
                        [ngClass]="{'ng-invalid ng-dirty': groupDatosComerciales.get('billingContact.birthday')?.invalid && groupDatosComerciales.get('billingContact.birthday')?.touched}"></p-datepicker>
                      <label for="fact_birthday">Cumpleaños</label>
                    </p-floatlabel>
                  </div>
                  <div>
                    <p-floatlabel variant="in" style="height: fit-content;">
                      <input formControlName="email" type="email" pInputText class="full-width"
                        [ngClass]="{'ng-invalid ng-dirty': groupDatosComerciales.get('billingContact.email')?.invalid && groupDatosComerciales.get('billingContact.email')?.touched}" />
                      <label for="fact_email">Correo Electrónico</label>
                    </p-floatlabel>
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="3">
              <p-accordion-header>
                <div class="accordion-header">
                  <i class="pi pi-cog accordion-icon" style="color: #0f4d7e;"></i>
                  <span>Contacto Operaciones</span>
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <div class="checkbox-item">
                  <p-checkbox formControlName="checkOpcionalOC" [binary]="true" inputId="checkOpcionalOC"></p-checkbox>
                  <label for="checkOpcionalOC">Hacer opcional</label>
                </div>
                <div class="form-section">
                  <div *ngFor="let contactGroup of operationsContactsArray.controls; let i = index"
                    [formGroup]="getFormGroup(contactGroup)" class="form-card">
                    <div class="form-card-header">

                      <h4 class="form-card-title">

                        Contacto Operaciones {{ i + 1 }}

                        <span *ngIf="contactGroup.get('replicateFromLogistics')?.value"
                          class="tag-replicated">Replicado</span>

                      </h4>

                      <p-button *ngIf="operationsContactsArray.length > 1 && !hasReplication(contactGroup)"
                        type="button" icon="pi pi-times" label="Eliminar"
                        styleClass="p-button-danger p-button-sm p-button-outlined"
                        (click)="removeOperationsContact(i)"></p-button>

                    </div>

                    <div class="mb-4">

                      <label class="label-email-type">Replicar Información de Contacto Logística
                        Internacional:</label>

                      <div [formGroupName]="'replicateFromLogistics'" class="email-types-container">

                        <div class="space-y-2">

                          <div class="flex-align-center"
                            *ngFor="let logContact of internationalLogisticsContactsArray.controls; let logIndex = index">

                            <p-checkbox [binary]="true" [formControlName]="'log_contact_' + logContact.get('id')?.value"
                              inputId="op_replicate_log_{{logContact.get('id')?.value}}-{{contactGroup.get('id')?.value}}-{{i}}"
                              (onChange)="replicateLogisticsToOperations(getFormGroup(contactGroup), logContact.get('id')?.value, $event.checked)"></p-checkbox>


                            <!-- [disabled]="!hasAnyValue('logistics', getFormGroup(logContact))" -->

                            <label
                              for="op_replicate_log_{{logContact.get('id')?.value}}-{{contactGroup.get('id')?.value}}-{{i}}"
                              class="label-checkbox">

                              Contacto {{ logIndex + 1 }}


                            </label>

                          </div>

                        </div>

                      </div>

                    </div>
                    <div class="form-space-y">
                      <div class="form-grid">
                        <p-floatlabel variant="in">
                          <input formControlName="name" type="text" pInputText class="full-width"
                            [ngClass]="{'ng-invalid ng-dirty': contactGroup.get('name')?.invalid && contactGroup.get('name')?.touched}" />
                          <label for="op_name-{{contactGroup.get('id')?.value}}">Nombre</label>
                        </p-floatlabel>
                        <p-floatlabel variant="in">
                          <input formControlName="lastName" type="text" pInputText class="full-width"
                            [ngClass]="{'ng-invalid ng-dirty': contactGroup.get('lastName')?.invalid && contactGroup.get('lastName')?.touched}" />
                          <label for="op_lastName-{{contactGroup.get('id')?.value}}">Apellido</label>
                        </p-floatlabel>
                      </div>
                      <div>
                        <p-floatlabel variant="in">
                          <input formControlName="position" type="text" pInputText class="full-width"
                            [ngClass]="{'ng-invalid ng-dirty': contactGroup.get('position')?.invalid && contactGroup.get('position')?.touched}" />
                          <label for="op_position-{{contactGroup.get('id')?.value}}">Puesto</label>
                        </p-floatlabel>
                      </div>
                      <div class="form-grid">
                        <p-floatlabel variant="in">
                          <input formControlName="phone" id="op_phone-{{contactGroup.get('id')?.value}}" type="tel"
                            pInputText class="full-width"
                            [ngClass]="{'ng-invalid ng-dirty': contactGroup.get('phone')?.invalid && contactGroup.get('phone')?.touched}" />
                          <label for="op_phone-{{contactGroup.get('id')?.value}}">Teléfono</label>
                        </p-floatlabel>
                        <p-floatlabel variant="in">
                          <p-datepicker inputId="op_birthday-{{contactGroup.get('id')?.value}}"
                            formControlName="birthday" appendTo="body" showIcon iconDisplay="input" class="full-width"
                            [ngClass]="{'ng-invalid ng-dirty': contactGroup.get('birthday')?.invalid && contactGroup.get('birthday')?.touched}"></p-datepicker>
                          <label for="op_birthday-{{contactGroup.get('id')?.value}}">Cumpleaños</label>
                        </p-floatlabel>
                      </div>
                      <div class="form-grid">
                        <p-floatlabel variant="in" style="height: fit-content;">
                          <input formControlName="email" type="email" pInputText class="full-width"
                            [ngClass]="{'ng-invalid ng-dirty': contactGroup.get('email')?.invalid && contactGroup.get('email')?.touched}" />
                          <label for="op_email-{{contactGroup.get('id')?.value}}">Correo Electrónico</label>
                        </p-floatlabel>
                        <div>
                          <label class="label-email-type">Tipo de Correo</label>
                          <div [formGroupName]="'emailTypes'"
                            [ngClass]="{'ng-invalid ng-dirty': contactGroup.get('emailTypes')?.invalid && contactGroup.get('emailTypes')?.touched}">
                            <div class="space-y-2">
                              <div class="flex-align-center">
                                <p-checkbox formControlName="mandato" [binary]="true"
                                  inputId="op_mandato-{{contactGroup.get('id')?.value}}"></p-checkbox>
                                <label for="op_mandato-{{contactGroup.get('id')?.value}}"
                                  class="label-checkbox">Mandato</label>
                              </div>
                              <div class="flex-align-center">
                                <p-checkbox formControlName="otrosTraficos" [binary]="true"
                                  inputId="op_otros-traficos-{{contactGroup.get('id')?.value}}"></p-checkbox>
                                <label for="op_otros-traficos-{{contactGroup.get('id')?.value}}"
                                  class="label-checkbox">Otros tráficos</label>
                              </div>
                              <div class="flex-align-center">
                                <p-checkbox formControlName="exportacion" [binary]="true"
                                  inputId="op_exportacion-{{contactGroup.get('id')?.value}}"></p-checkbox>
                                <label for="op_exportacion-{{contactGroup.get('id')?.value}}"
                                  class="label-checkbox">Exportación</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-actions">
                    <p-button type="button" icon="pi pi-plus" label="Agregar Nuevo Contacto"
                      styleClass="p-button-info p-button-rounded" (click)="addNewOperationsContact()"></p-button>
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="4">
              <p-accordion-header>
                <div class="accordion-header">
                  <i class="pi pi-file-excel accordion-icon" style="color: #0f4d7e;"></i>
                  <span>Archivos</span>
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <div class="form-section">
                  <div class="checkbox-item">
                    <p-checkbox formControlName="checkOpcionalCustomerProfile" [binary]="true"
                      inputId="checkOpcionalCustomerProfile"></p-checkbox>
                    <label for="checkOpcionalCustomerProfile">Hacer opcional</label>
                  </div>
                  <div class="a-w1-column">
                    <div class="a-w1-row">
                      <div class="a-example-full-width-alterno-content-row"
                        style="justify-content: space-between; margin-bottom: 1%;">

                        <a href="assets/doc/Formatos_Vtas.xlsx" download="Formatos_Vtas.xlsx" class="download-link">
                          <i class="pi pi-download download-icon"></i>
                          Descargar Customer Profile Template.xlsx
                        </a>

                      </div>
                    </div>
                    <label class="font-bold">Adjuntar nuevo archivo:</label>
                    <div class="a-w1-row">
                      <p-fileUpload #fileUploader2 mode="basic" chooseLabel="Seleccionar Archivo"
                        chooseIcon="pi pi-upload" name="demo[]" (onSelect)="onSend($event)" [maxFileSize]="1000000">
                        <ng-template #empty>
                          <div>Selecciona un archivo para adjuntar.</div>
                        </ng-template>
                      </p-fileUpload>
                      <p-button label="Eliminar Archivo" icon="pi pi-times" styleClass="p-button-danger"
                        (onClick)="clearFileSelection()"></p-button>
                    </div>

                    <label class="font-bold">Archivos anteriores:</label>

                    <ng-container *ngIf="cargandoArchivos; else mostrarListaArchivos">
                      <div class="flex justify-content-center p-4">
                        <p-progressSpinner styleClass="custom-spinner" strokeWidth="4"></p-progressSpinner>
                      </div>
                    </ng-container>

                    <ng-template #mostrarListaArchivos>
                      <ng-container *ngIf="uploadedFilesComercial.length > 0; else noFiles">
                        <ul style="list-style-type: none; padding: 0;">
                          <li *ngFor="let file of uploadedFilesComercial">
                            <div class="a-example-full-width-alterno-content-row"
                              style="justify-content: space-between; margin-bottom: 1%;">

                              <div class="a-example-full-width-alterno-content-6 centrar"
                                style="justify-content: right;">
                                <img [src]="util.getFileIcon(file.nombreArchivo)" alt="file icon"
                                  style="max-width: 30px; max-height: 30px; object-fit: contain;">
                              </div>

                              <div class="a-example-full-width-alterno-content-0_2 centrar label">
                                {{ file.nombreArchivo }}
                              </div>

                              <div class="a-example-full-width-alterno-content-6" style="margin-right: 1%;">
                                <p-button icon="pi pi-download" class="p-button-secondary"
                                  (onClick)="descargarArchivo(file)"></p-button>

                                <!-- <p-button icon="pi pi-times" class="p-button-danger"
                                  (onClick)="onFileRemove(file)"></p-button> -->
                              </div>

                            </div>
                          </li>
                        </ul>
                      </ng-container>
                    </ng-template>


                    <ng-template #noFiles>
                      <p class="text-gray-500">No hay archivos adjuntados.</p>
                    </ng-template>

                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
          <!-- <div class="row">
            <div class="col">
                <p-button type="submit">
                {{ modo === "EDITAR" ? 'Actualizar' : 'Guardar' }}
                </p-button>
            </div>
          </div> -->
        </div>
      </form>
    </p-tabPanel>
    <p-tabPanel header="Otros Datos">
      <p-toast key="toast1"></p-toast>
      <p-toast key="toast2"></p-toast>
      <p-toast key="toast3"></p-toast>
      <p-accordion [activeIndex]="[0]" [multiple]="true">
        <p-accordionTab header="Servicios">
          <app-datatable [rowEdit]="true" [addRow]="true" [rowDelete]="true" [metadataTable]="metadataTableServicios"
            [dataTable]="dataTableServicios" [key]="'key'" [defaultRow]="defaultRowServicios"
            (onDpChangeEvento)="onServiciosChange($event)" [onDpValueChangeEvento]="onDpChangeTblServicios"
            [filtro]="false">
          </app-datatable>
          <div class="example-full-width-alterno100" style="margin-top: 20px;">
            <app-datatable [metadataTable]="metadataTableAuditoriaServicios" [dataTable]="dataTableAuditoriaServicios"
              [key]="'key'" [customButtons]="customAuditoriaServicios" [title]="'AUDITORIA DE SERVICIOS'"
              [filtro]="false">
            </app-datatable>
          </div>
        </p-accordionTab>
      </p-accordion>
    </p-tabPanel>
    <p-tabPanel header="Datos Financieros">
      <p-toast key="toast1"></p-toast>
      <p-toast key="toast2"></p-toast>
      <p-toast key="toast3"></p-toast>
      <p-accordion [activeIndex]="[0]" [multiple]="true">
        <p-accordionTab header="Datos Financieros">
          <form [formGroup]="groupPoppupD" class="a-w1" style="margin: 0;">
            <div class="a-w1-row">
              <div class="a-w2" style="display: flex; gap: 20px; justify-content: center; align-items: center;">
                <div class="flex align-items-center gap-1">
                  <span class="p-float-label">
                    <p-checkbox formControlName="esMandato" [binary]="true" inputId="binary"></p-checkbox>
                    <label style="padding-left: 20px;">Mandato</label>
                  </span>
                </div>
              </div>
              <div class="a-w2" style="display: flex; gap: 20px; justify-content: center; align-items: center;">
                <div class="flex align-items-center gap-1">
                  <span class="p-float-label">
                    <p-checkbox formControlName="esExportaciones" [binary]="true" inputId="binary"></p-checkbox>
                    <label style="padding-left: 20px;">Exportaciones</label>
                  </span>
                </div>
              </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;">
              <div class="a-w2" style="display: flex; gap: 20px; justify-content: center; align-items: center;">
                <div class="flex align-items-center gap-1">
                  <span class="p-float-label">
                    <p-checkbox formControlName="esOtrosTraficos" [binary]="true" inputId="binary"></p-checkbox>
                    <label style="padding-left: 20px;">Otros Tráficos</label>
                  </span>
                </div>
              </div>
              <div class="a-w2" style="display: flex; gap: 20px; justify-content: center; align-items: center;">
                <div class="flex align-items-center gap-1">
                  <span class="p-float-label">
                    <p-checkbox formControlName="esSli" [binary]="true" inputId="binary"></p-checkbox>
                    <label style="padding-left: 20px;">SLI</label>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>
        <p-accordionTab header="Límite de Crédito">
          <p-toast key="toast3"></p-toast>
          <app-datatable [metadataTable]="metadataTableLimiteCredito" [dataTable]="dataTableLimiteCredito"
            [addRow]="true" [rowEdit]="true" [key]="'key'">
            <ng-template #addHeaderEnd>
              <th class="header">
              </th>
            </ng-template>
            <ng-template #addBodyEnd let-row="row">
              <td class="a-datatable-datos-body-accion row-space">
                <p-button icon="pi pi-history" styleClass="p-button-rounded p-button-warning p-button-outlined"
                  (onClick)="op.toggle($event)" pTooltip="Ver Historial" tooltipPosition="top"></p-button>
              </td>
              <p-overlayPanel #op [style]="{'width': '630px'}" (onShow)="verHistorial('',row)">
                <ng-template pTemplate="content">
                  <app-datatable [metadataTable]="metadataTableHistorial" [dataTable]="dataTableHistorial">
                  </app-datatable>
                </ng-template>
              </p-overlayPanel>
            </ng-template>
          </app-datatable>
        </p-accordionTab>

        <p-accordionTab header="Bloqueo">
          <form [formGroup]="groupPoppupB" class="a-w1" style="margin: 0;">
            <div class="a-w1-row">
              <div class="a-w1">
                <span class="p-float-label" class="activo-centrado">
                  <div class="flex align-items-center gap-1">
                    <p-checkbox formControlName="bloqueado" [binary]="true" inputId="binary"
                      (ngModelChange)="cargarInputBloqueo($event)"></p-checkbox>
                    <label for="activo">Bloqueado</label>
                  </div>
                </span>
              </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;">
              <div class="a-w2">
                <p-float-label variant="on">
                  <input formControlName="usuariobloqueo" type="text" pInputText />
                  <label for="float-label">Usuario</label>
                </p-float-label>
              </div>
              <div class="a-w2">
                <!-- <span class="p-float-label">
                                  <p-datepicker formControlName="fechabloqueoo" appendTo="body" [showIcon]="true"
                                      class="p-inputtext-sm" dateFormat="dd/mm/yy">
                                  </p-datepicker>
                                  <label for="float-label">Fecha Bloqueo</label>
                              </span> -->
                <p-floatlabel variant="on">
                  <p-datepicker formControlName="fechabloqueoo" appendTo="body" [showIcon]="true" class="p-inputtext-sm"
                    dateFormat="dd/mm/yy" styleClass="w-full md:w-full" inputStyleClass="w-full md:w-full">
                  </p-datepicker>
                  <label for="float-label">Fecha Bloqueo</label>
                </p-floatlabel>
              </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;">
              <div class="a-w1">
                <span style="font-size: 15px; display: flex;padding-top: 20px; padding-bottom: 15px;">Comentarios</span>
                <span class="p-float-label">
                  <textarea rows="5" cols="30" pInputTextarea formControlName="comentariobloqueo"
                    style="width: 100%;"></textarea>
                </span>
              </div>
            </div>
          </form>
        </p-accordionTab>
      </p-accordion>
    </p-tabPanel>
    <p-tabPanel header="Relacionados">
      <div style="min-height:600px;">
        <p-toast key="toast1"></p-toast>
        <p-toast key="toast2"></p-toast>
        <p-toast key="toast3"></p-toast>
        <form *ngIf="estadoEditar" [formGroup]="groupPoppupE" class="a-w1" style="margin: 0;">
          <div class="a-titulo">Datos del Cliente</div>
          <div class="a-example-full-width-alterno-content a-example-full-width-alterno-content-row">
            <div class="a-example-full-width-alterno-content-4">
              <p-floatlabel variant="in">
                <p-select [options]="ListaTodosTipoEntidad" placeholder="‎ " optionLabel="nombre"
                  formControlName="tipoentidad" optionValue="codigo" appendTo="body" class="w-full md:w-full">
                </p-select>
                <label for="float-label">Tipo de Entidad</label>
              </p-floatlabel>
            </div>
            <div class="a-example-full-width-alterno-content-4">
              <p-floatlabel variant="in">
                <p-floatlabel variant="in">
                  <input formControlName="numdocumento" type="text" pInputText />
                  <label for="float-label">Número Documento</label>
                </p-floatlabel>
              </p-floatlabel>
            </div>
            <div class="a-example-full-width-alterno-content-4">
              <p-floatlabel variant="in">
                <p-floatlabel variant="in">
                  <input formControlName="razonsocial" type="text" pInputText />
                  <label for="float-label">Razón Social</label>
                </p-floatlabel>
              </p-floatlabel>
            </div>
          </div>

        </form>
        <div>
          <div class="a-titulo" style="margin-top: 4px;">Datos del Relacionado</div>
          <app-datatable #dtEntidadRef [rowEdit]="true" [addRow]="true" [rowDelete]="true"
            [metadataTable]="metadataTableRelacionados" [dataTable]="dataTableRelacionados" [key]="'key'"
            [defaultRow]="defaultRowRelacionados" (onDpChangeEvento)="onEntidadChange($event)"
            [onDpValueChangeEvento]="onDpChangeTblRelacionados">
          </app-datatable>
          <!-- <p-floatlabel variant="in" class="input-half-width">
          <p-select [options]="listadoGrupos" optionLabel="filtro_cliente" formControlName="grupoCliente"
            optionValue="entC_Codigo" [filter]="true" filterBy="filtro_cliente" appendTo="body" styleClass="w-full md:w-full text-xs" />
          <label for="grupoCliente">Seleccionar grupo</label>
        </p-floatlabel> -->
          @if(this.procesoAgrupacion === true){
          <h3>Seleccione un cliente o grupo para agrupar</h3>
          <app-custom-select [options]="listadoGrupos" [optionLabel]="'filtro_cliente'" [optionValue]="'entC_Codigo'"
            [placeholder]="'Seleccionar grupo'" (selectionChange)="onGroupSelectionChange($event)">
          </app-custom-select>
          }

        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Archivos">
      <p-toast key="toast1"></p-toast>
      <p-toast key="toast2"></p-toast>
      <p-toast key="toast3"></p-toast>
      <div>
        <p-fileUpload chooseLabel="Seleccionar Archivo" name="demo[]" [multiple]="true"
          url="https://www.primefaces.org/cdn/api/upload.php" [style]="{'width': '100%'}"
          accept="image/*,.xls,.xlsx,.pdf.docx,.txt,.doc" [maxFileSize]="1000000" (onSelect)="onUpload($event)"
          [auto]="true">
          <ng-template pTemplate="content" style="display: none;"></ng-template>
        </p-fileUpload>
        <!-- <p-button label="Guardar" icon="pi pi-save" (onClick)="onUpload($event)"></p-button> -->
        <div style="padding-top: 10px;">
          <p-table [value]="uploadedFiles" [tableStyle]="{'width': '100%','font-size': '13px', 'padding': '2px'}">
            <ng-template pTemplate="header">
              <tr>
                <th style="width:5%">Descargar</th>
                <th style="width:5%">Eliminar</th>
                <th style="width:17%">Tipo Doc.</th>
                <th style="width:18%">Usuario Crea</th>
                <th style="width:17%">Fecha Crea</th>
                <th style="width:36%">Nombre</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [class.deleted-row]="row.tipotran === 'D'">
                <td><p-button class="btnsmall" icon="pi pi-download"
                    styleClass="p-button-rounded p-button-outlined p-button-sm"
                    (onClick)="downloadArchivo('', row)"></p-button></td>
                <td>
                  <p-button [icon]="row.tipotran === 'D' ? 'pi pi-undo' : 'pi pi-times'"
                    [styleClass]="'p-button-rounded p-button-outlined p-button-sm ' + (row.tipotran === 'D' ? 'p-button-success' : 'p-button-danger')"
                    (onClick)="deleteArchivo(row)"></p-button>
                </td>
                <td><img [src]="obtenerIconoTipoArchivo(row.nombre)"
                    style="width: 35px; height: 35px; margin-right: 10px;"></td>
                <td>{{ row.usuario }}</td>
                <td>{{ row.fecha }}</td>
                <td>{{ row.nombre }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Auditoría">
      <p-toast key="toast1"></p-toast>
      <p-toast key="toast2"></p-toast>
      <p-toast key="toast3"></p-toast>
      <app-datatable [metadataTable]="metadataTableAuditoria" [dataTable]="dataTableAuditoria"
        [customButtons]="dataButtons">
      </app-datatable>
    </p-tabPanel>
  </p-tabView>
</p-dialog>
<p-dialog [(visible)]="dialogVisibleValidacion" [modal]="true" [closable]="false" [baseZIndex]="1001" appendTo="body"
  [style]="{width: '450px'}">
  <div class="header-validacion">
    <h3>{{ dialogData.titulo }}</h3>
  </div>
  <div class="content-validacion">
    <div class="p-text-center">
      <h4>Mensaje:</h4>
      <p>{{ dialogData.mensaje }}</p>
    </div>
    @if(dialogData.observacion){
    <div class="p-text-center">
      <h4>Observación:</h4>
      <p style="white-space: pre-wrap;">{{ dialogData.observacion }}</p>
    </div>
    }
  </div>

  <ng-template pTemplate="footer" class="footer-validacion">
    <button pButton type="button" class="p-button-success" [label]="dialogData.textoBtnOpcion1"
      (click)="dialogData.onAccept()">
    </button>

    <button pButton type="button" class="p-button-secondary" [label]="dialogData.textoBtnOpcion2"
      (click)="dialogData.onReject()">
    </button>
    <button pButton type="button" *ngIf="dialogData?.textoBtnOpcion3" (click)="dialogData?.onOpcion3()">
      {{ dialogData?.textoBtnOpcion3 }}
    </button>
  </ng-template>
</p-dialog>